import React, { useEffect, useState } from 'react';
import 'bootstrap-select';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LoadingSpinner from 'component/LoadingSpinner';
import CustomDropdown from 'component/CustomDropdown';
import ProjectService from 'service/ProjectService';
import { ProjectCreateReq } from 'domain/payload/request/project/ProjectCreateReq';
import { Value } from 'domain/model/Value';
import MultiSelectDropdown from 'component/MultiSelectDropdown';
import { Option } from 'domain/model/Option';
import { ProjectTaskAssignReq } from 'domain/payload/request/project/ProjectTaskAssignReq';
import AmountInput from 'component/AmountInput';

const ProjectTaskForm: React.FC = () => {
  const { id } = useParams();
  const { profile } = useSelector((state: any) => state.auth);

  const navigate = useNavigate();
  const projectService = ProjectService();

  // INPUT STATE
  const [taskType, setTaskType] = useState<number | null>(null);
  const [goodsIds, setGoodsIds] = useState<string[]>([]);
  const [storeIds, setStoreIds] = useState<string[]>([]);
  const [areaIds, setAreaIds] = useState<string[]>([]);
  const [fee, setFee] = useState(0);
  const [installerId, setInstallerId] = useState('');
  const [instructionFormId, setInstructionFormId] = useState('');
  const [description, setDescription] = useState('');

  // LOADING
  const [isLoadingConfig, setIsLoadingConfig] = useState(false);
  const [isLoadingSave, setIsLoadingSave] = useState(false);

  // CONFIG
  const [taskTypeList, setTaskTypeList] = useState<Option[]>([]);
  const [goodsList, setGoodsList] = useState<Value[]>([]);
  const [formList, setFormList] = useState<Value[]>([]);
  const [installerList, setInstallerList] = useState<Value[]>([]);
  const [placeList, setPlaceList] = useState<Value[]>([]);
  const [areaList, setAreaList] = useState<Value[]>([]);
  const [formDefaultid, setFormDefaultId] = useState<string>("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoadingSave(true);
    try {
      await projectAssign();
      alert(`Assignment sent`);
      navigate("/project");
    } catch (err: any) {
      console.error(err);
      const errorMessage = err.response?.data?.message || err.message || 'Terjadi kesalahan saat mengirim assignment';
      alert(`Error: ${errorMessage}`);
    } finally {
      setIsLoadingSave(false);
    }
  };

  const fetchConfig = async () => {
    const token = profile?.data.token;
    if (!token) {
      window.alert('Token tidak ditemukan. Silakan login kembali.');
      return;
    }
    setIsLoadingConfig(true);
    try {
      const res = await projectService.projectTaskConfig(token, id!);
      setTaskTypeList(res.data?.taskTypeList || []);
      setPlaceList(res.data?.placeList || []);
      setAreaList(res.data?.areaList || []);
      setGoodsList(res.data?.goodsList || []);
      setInstallerList(res.data?.installerList || []);
      setFormList(res.data?.formList || []);

      // set default instruction
      setInstructionFormId(res.data?.formDefaultId || "")
    } catch (err: any) {
      console.error(err);
      const errorMessage = err.response?.data?.message || err.message || 'Terjadi kesalahan saat mengambil konfigurasi';
      window.alert(`Error: ${errorMessage}`);
    } finally {
      setIsLoadingConfig(false);
    }
  };

  const projectAssign = async () => {
    const token = profile?.data.token;
    if (!token) {
      window.alert('Token tidak ditemukan. Silakan login kembali.');
      return;
    }

    try {
      const request: ProjectTaskAssignReq = {
        taskTypeKey: taskType!,
        projectId: id!,
        goodsIds: goodsIds,
        placeIds: storeIds,
        areaIds: areaIds,
        installerId: installerId,
        fee: fee,
        instructionFormId: instructionFormId,
        description: description
      };
      console.log(request)
      await projectService.projectTaskAssign(token, request);
    } catch (err) {
      console.error(err);
      throw err
    }
  };

  useEffect(() => {
    fetchConfig();
  }, []);

  return (
    <div className="pt-1 h-100" style={{ background: '#f2f4f8' }}>
      <div className="m-4">
        <h4 className="mb-4">{"Project Assignment"}</h4>
        <div className="p-4" style={{ background: 'white' }}>
          {isLoadingConfig ? <LoadingSpinner /> :
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-sm-6">
                  <h5 className="mb-4">Task's Detail</h5>
                  <div className="mb-3">
                    <label className="form-label fw-semibold">Task Type</label>
                    <CustomDropdown
                      value={taskType ?? ''}
                      options={taskTypeList.map(c => ({
                        id: c.key,
                        name: c.value
                      }))}
                      onChange={(option) => setTaskType(Number(option.id))}
                      placeholder="-- Select Task Type --"
                      containerClassName="w-100"
                      buttonClassName="form-control form-control-compact w-100 d-flex align-items-center justify-content-between text-start bg-white text-dark border rounded-3"
                    />
                  </div>
                  {
                    taskType == 1 &&
                    <>
                      <div className="mb-3">
                        <label className="form-label fw-semibold">Goods</label>
                        <MultiSelectDropdown
                          options={goodsList.map(i => ({ code: i.id, name: i.name }))}
                          placeholder="Choose Goods..."
                          onChange={setGoodsIds}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label fw-semibold">Places</label>
                        <MultiSelectDropdown
                          options={placeList.map(i => ({ code: i.id, name: i.name }))}
                          placeholder="Choose Place..."
                          onChange={setStoreIds}
                        />
                      </div>
                    </>
                  }
                  {
                    taskType == 2 &&
                    <>
                      <div className="mb-3">
                        <label className="form-label fw-semibold">Areas</label>
                        <MultiSelectDropdown
                          options={areaList.map(i => ({ code: i.id, name: i.name, description: i.description }))}
                          placeholder="Choose Area..."
                          onChange={setAreaIds}
                          previewKey="name"
                          subKey="description"
                        />
                      </div>
                    </>
                  }
                  {
                    taskType == 3 &&
                    <>
                      <div className="mb-3">
                        <label className="form-label fw-semibold">Places</label>
                        <MultiSelectDropdown
                          options={placeList.map(i => ({ code: i.id, name: i.name, description: i.description }))}
                          placeholder="Choose Place..."
                          onChange={setStoreIds}
                          previewKey="name"
                          subKey="description"
                        />
                      </div>
                    </>
                  }
                  <div className="mb-3">
                    <label className="form-label fw-semibold">Fee</label>
                    <AmountInput
                      value={fee}
                      onChange={setFee}
                      className="form-control form-control-compact"
                      required
                    />
                  </div>
                </div>

                <div className="col-sm-6">
                  <h5 className="mb-4">Additional Information</h5>
                  <div className="mb-3">
                    <label className="form-label fw-semibold">Description</label>
                    <input type="text" className="form-control form-control-compact" value={description} onChange={e => setDescription(e.target.value)} required />
                  </div>
                </div>

                <p />

                <div className="col-sm-6">
                  <h5 className="mb-4">Assignment</h5>
                  <div className="mb-3">
                    <label className="form-label fw-semibold">Field User</label>
                    <MultiSelectDropdown
                      options={installerList.map(i => ({ code: i.id, name: i.name }))}
                      placeholder="Choose Field User..."
                      onChange={(e) => setInstallerId(e[0])}
                      single={true}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label fw-semibold">Form Instructions</label>
                    <CustomDropdown
                      value={instructionFormId}
                      options={formList.map(c => ({
                        id: c.id,
                        name: c.name
                      }))}
                      onChange={(option) => setInstructionFormId(String(option.id))}
                      placeholder="Select Form"
                      containerClassName="w-100"
                      buttonClassName="form-control form-control-compact w-100 d-flex align-items-center justify-content-between text-start bg-white text-dark border rounded-3"
                    />
                  </div>
                </div>
              </div>

              <div className="w-100 d-flex justify-content-end">
                <Link to={`/project/detail/${id}`}>
                  <button type="button" className="btn btn-outline-primary">Cancel</button>
                </Link>
                <button type="submit" className="btn btn-primary ms-2" disabled={isLoadingSave}>
                  {isLoadingSave && <LoadingSpinner reverse />}
                  Assign
                </button>
              </div>
            </form>
          }
        </div>
      </div>
    </div>
  );
};

export default ProjectTaskForm;